import React, { FunctionComponent, useContext, useState } from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { FocusableHeader, SimpleHeader, CountyPicker } from "../../components";
import { useTranslate, useQueryParams } from "../../helpers";
import { County, ActionType } from "../../@types";
import { AppContext } from "../../app/store";
import { Routes } from "../../app";
import { Button } from "@cmsgov/ds-medicare-gov";

const CoverageWizardLandingPage: FunctionComponent<RouteComponentProps> = props => {
  const t = useTranslate();
  const {
    dispatch,
    state: { fips, zipcode },
  } = useContext(AppContext);

  const [county, setCounty] = useState<County | undefined>();

  useQueryParams(props);

  const onCountySelect = (county?: County, zipcode?: string): void => {
    if (county && zipcode) {
      if (county) {
        dispatch({ type: ActionType.UPDATE_COUNTY, payload: county });
        dispatch({ type: ActionType.UPDATE_FIPS, payload: county.fips });
        setCounty(county);
      }

      if (zipcode) {
        dispatch({ type: ActionType.UPDATE_ZIPCODE, payload: zipcode });
      }
    }
  };

  return (
    <div className="CoverageWizardLandingPage">
      <div className="CoverageWizardLandingPage__hero">
        <SimpleHeader noBorder={true} variation="dark" />
        <div className="CoverageWizardLandingPage__heroContent">
          <FocusableHeader
            className="CoverageWizardLandingPage__heroHeader"
            text={t("coveragewizard.landing.header")}
            ignoreFocus={false}
          />
          <div className="CoverageWizardLandingPage__heroSubheader">
            {t("coveragewizard.landing.subheader")}
            <br />
            {t("coveragewizard.landing.subheader_2")}
          </div>
        </div>
      </div>

      <div className="CoverageWizardLandingPage__content">
        <div className="CoverageWizardLandingPage__card">
          <div>
            <CountyPicker
              className="CoverageWizardLandingPage__statePicker"
              label={t("coveragewizard.landing.enter_zip")}
              onCountySelect={onCountySelect}
              initialFips={fips}
              initialZip={zipcode}
              buttonLabel={t("start")}
            />

            {county && (
              <Button
                variation="primary"
                className="ds-u-margin-top--2"
                size="big"
                onClick={(): void =>
                  props.history.push(Routes.coverageWizard.options)
                }
              >
                {t("next")}
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(CoverageWizardLandingPage);
